import React from "react";
import ev1 from "../../assets/event1.png";
import ev2 from "../../assets/event2.png";

import ev3 from "../../assets/event3.png";
import ev4 from "../../assets/event4.png";

const EVENTS_THUMBNAIL = [
  { image: ev1, title: "Web Summit Vancouver 2025 ", subTitle: "2025, Canada" },
  {
    image: ev2,
    title: "Dublin Tech Summit 2024 ",
    subTitle: "Dublin, Ireland",
  },
  { image: ev3, title: "Web Summit Lisbon", subTitle: "2023, Portugal" },
  { image: ev4, title: "London Tech Week", subTitle: "2024 – United Kingdom" },
];

const Events = () => {
  return (
    <div className="bg-[#F5F5F5]">
      <div className="max-w-[1920px] mx-auto px-6  py-8 lg:py-12 xl:py-16 2xl:py-20">
        <h2 className="text-black text-center leading-[38px] text-[32px] font-bold">
          Events
        </h2>
        <div className="mt-8 lg:mt-10 2xl:mt-16 flex gap-6 lg:gap-8 2xl:gap-12 items-center justify-center">
          {EVENTS_THUMBNAIL.map((item, idx) => (
            <div
              key={idx}
              className="relative cursor-pointer overflow-hidden group"
            >
              <img src={item.image} alt={item.title} />
              <div className="absolute inset-0 bg-[#923D8C94] opacity-0 transition-opacity duration-300 group-hover:opacity-100 flex flex-col items-center justify-center text-center">
                <p className="text-white text-2xl leading-7 font-bold opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  {item.title}
                </p>
                <p className="text-xl text-white leading-[23px] opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  {item.subTitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Events;
